import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { engageNestedRoutes } from '../../app-routes';
import type { LaunchDarklyFlags } from '../../types/launch-darkly';
import { EngageSettingsNavigator } from './EngageSettingsNavigator';
import { EditAutomationTemplate } from './edit-automation-template';
import { EditSegmentPage } from './edit-segment';
import { EngageSettingsTab } from './engage-settings-tab';

export const EngageSetup: React.FC = () => {
  const flags = useFlags<LaunchDarklyFlags>();
  const enablePartnerAutomationEditor =
    flags['partner-automation-editor'] ?? false;

  // Routes are relative to /dashboard/engage/* where this component is rendered
  return (
    <div className="space-y-6">
      {enablePartnerAutomationEditor ? (
        <Routes>
          <Route
            path={engageNestedRoutes.AUTOMATIONS_EDIT}
            element={<EditAutomationTemplate />}
          />
          <Route
            path={engageNestedRoutes.SEGMENTS_EDIT}
            element={<EditSegmentPage />}
          />
          <Route path=":tab?" element={<EngageSettingsNavigator />} />
        </Routes>
      ) : (
        <EngageSettingsTab />
      )}
    </div>
  );
};
